const API_PATH = '/api/studio-translations';

async function request(method, localeCode, body = null) {
  const response = await fetch(`${API_PATH}?localeCode=${encodeURIComponent(localeCode)}`, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error || `Translation service returned ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return payload;
}
export const loadCloudTranslationReview = (localeCode) => request('GET', localeCode);
export const saveCloudTranslationEntry = (localeCode, entry) => request('PUT', localeCode, { entry });
export const runTranslationWorkflow = (localeCode, action, comment = '', catalogueDigest = '', area = null, clinicalApprovalReference = '') => request('POST', localeCode, { action, comment, catalogueDigest, area, clinicalApprovalReference });
export const exportApprovedTranslationReview = async (localeCode) => { const response = await fetch(`${API_PATH}?localeCode=${encodeURIComponent(localeCode)}&format=review_export`, { credentials: 'same-origin' }); const payload = await response.json(); if (!response.ok) throw new Error(payload.error || 'Unable to export review'); return payload; };

export async function loadTranslationAdminDashboard() {
  const response = await fetch(`${API_PATH}?format=dashboard`, { credentials: 'same-origin' });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || 'Unable to load professional translation dashboard');
  return payload;
}
export async function exportApprovedTranslationArea(localeCode, area) {
  const response = await fetch(`${API_PATH}?localeCode=${encodeURIComponent(localeCode)}&format=area_export&area=${encodeURIComponent(area)}`,
    { credentials: 'same-origin' });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || 'Unable to export approved content area');
  return payload;
}
